module.exports = __webpack_public_path__ + "img/blog-single-01.61afffe2.png";